import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "mb-2 w-full" }
const _hoisted_3 = { class: "flex items-center mb-4" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "mb-2 w-full" }
const _hoisted_6 = { class: "flex items-center mb-4" }
const _hoisted_7 = ["textContent"]
const _hoisted_8 = ["textContent"]
const _hoisted_9 = ["textContent"]
const _hoisted_10 = ["textContent"]
const _hoisted_11 = { class: "flex items-center justify-between mt-4" }
const _hoisted_12 = { class: "col-9" }
const _hoisted_13 = { class: "col-3 flex justify-end" }

import { ref, onMounted, computed } from 'vue';
import { CONFIGURATION } from '@/enum';
import Checkbox from 'primevue/checkbox';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

import { storeToRefs } from 'pinia';
import { useMessageCenterStore } from '@/store';
import type { AttachmentFileConfig, FileTypes } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'MessageCenter',
  setup(__props) {

const messageCenterStore = useMessageCenterStore();
const { configuration, getFileTypes, getFileConfigurations, error } = storeToRefs(messageCenterStore);

onMounted(async () => {
  await init();
});

const maxFiles = ref<number>(1);
const maxUploadSize = ref<number>(10);
const fileTypes = ref<FileTypes[]>([]);
const hasError = computed(() => !!error.value);

const init = async () => {
  await messageCenterStore.getMessageSettings();
  setupConfiguration();
};

const setupConfiguration = async () => {
  const cfg = getFileConfigurations.value;
  maxFiles.value = typeof cfg?.max_files === 'number' && cfg.max_files > 0 ? cfg.max_files : 1;
  maxUploadSize.value = typeof cfg?.max_upload_size === 'number' && cfg.max_upload_size > 0 ? cfg.max_upload_size : 10;

  fileTypes.value = configuration.value?.file_types ?? [];
};

const saveConfiguration = async () => {
  const newConfiguration: AttachmentFileConfig = {
    configurations: [
      {
        name: CONFIGURATION.MAX_FILES,
        value: maxFiles.value,
      },
      {
        name: CONFIGURATION.MAX_UPLOAD_SIZE,
        value: maxUploadSize.value,
      },
    ],
    file_types: fileTypes.value,
  };

  await messageCenterStore.updateMessageSettings(newConfiguration);
  await setupConfiguration();

  if (hasError.value) {
    const message = error.value.data.errors
      ? Object.values(error.value.data.errors).flat().join(', ')
      : error.value.data.message;

    messageCenterStore.doToast(message, 'Error', true, 5000);
    messageCenterStore.error = undefined;
  } else {
    messageCenterStore.doToast('Configuration saved successfully.', 'Success');
  }
};
const showInformation = (ext: string | undefined): boolean => {
  if (!ext) return false;
  const showInfoByExt = ['webm', 'ogg', 'm4a'];
  return showInfoByExt.includes(ext);
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Card = _resolveComponent("Card")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex items-center justify-between mb-2" }, [
            _createElementVNode("h2", { class: "text-lg font-semibold text-gray-800" }, "Max Files")
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("label", {
              for: "maxFiles",
              class: "text-sm font-medium text-gray-700 col-8"
            }, " Set the maximum number of files allowed for upload. ", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "maxFiles",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((maxFiles).value = $event)),
              type: "number",
              class: "p-inputtext p-component px-3 py-2 text-sm border border-gray-300 rounded-md w-1/3 col-4",
              min: "1",
              max: "10"
            }, null, 512), [
              [
                _vModelText,
                maxFiles.value,
                void 0,
                { number: true }
              ]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex items-center justify-between mb-2" }, [
            _createElementVNode("h2", { class: "text-lg font-semibold text-gray-800" }, "Max Upload Size")
          ], -1)),
          _createElementVNode("div", _hoisted_6, [
            _cache[4] || (_cache[4] = _createElementVNode("label", {
              for: "maxUploadSize",
              class: "text-sm font-medium text-gray-700 col-8"
            }, " Set the maximum file size allowed for uploads (in megabytes). ", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "maxUploadSize",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((maxUploadSize).value = $event)),
              type: "number",
              class: "p-inputtext p-component px-3 py-2 text-sm border border-gray-300 rounded-md w-1/3 col-4",
              min: "1",
              max: "1024"
            }, null, 512), [
              [
                _vModelText,
                maxUploadSize.value,
                void 0,
                { number: true }
              ]
            ])
          ])
        ])
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "flex justify-between items-center mb-2" }, [
        _createElementVNode("h2", { class: "text-lg font-semibold" }, "Allowed File Types")
      ], -1)),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "flex items-center" }, [
        _createElementVNode("span", { class: "text-sm font-medium text-gray-700 col-8" }, "Manage allowed file types for different categories.")
      ], -1)),
      _createVNode(_unref(DataTable), {
        value: fileTypes.value,
        rows: fileTypes.value.length || 1,
        "responsive-layout": "scroll",
        "sort-field": "category",
        "row-group-mode": "rowspan",
        "group-rows-by": "category",
        "row-hover": true
      }, {
        empty: _withCtx(() => [...(_cache[6] || (_cache[6] = [
          _createTextVNode("No documents found", -1)
        ]))]),
        groupheader: _withCtx((slotProps) => [
          _createElementVNode("span", {
            textContent: _toDisplayString(slotProps.data.category)
          }, null, 8, _hoisted_10)
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(Column), {
            field: "category",
            header: "Category"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", {
                class: "font-bold text-gray-600",
                textContent: _toDisplayString(slotProps.data.category)
              }, null, 8, _hoisted_7)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "mime_type",
            header: "MIME type"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", null, _toDisplayString(slotProps.data.mime_type), 1),
              (showInformation(slotProps.data.ext))
                ? _withDirectives((_openBlock(), _createBlock(_component_Icon, {
                    key: 0,
                    name: "info",
                    class: "ml-3 text-gray-500 text-s"
                  }, null, 512)), [
                    [_directive_tooltip, slotProps.data.description]
                  ])
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "icon",
            header: "Icon"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", {
                textContent: _toDisplayString(slotProps.data.icon)
              }, null, 8, _hoisted_8)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "ext",
            header: "Extension"
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("span", {
                textContent: _toDisplayString(slotProps.data.ext)
              }, null, 8, _hoisted_9)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), { header: "Allowed" }, {
            body: _withCtx((slotProps) => [
              _createVNode(_unref(Checkbox), {
                modelValue: slotProps.data.allowed,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.allowed) = $event),
                binary: true
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "rows"]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _cache[7] || (_cache[7] = _createElementVNode("strong", null, "Currently allowed extensions: ", -1)),
          _createElementVNode("code", null, _toDisplayString(_unref(getFileTypes).map((type) => type.ext).join(', ')), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_AppButton, {
            text: "Save",
            type: "primary",
            style: {"margin-right":"0.5rem"},
            onClick: saveConfiguration
          }),
          _createVNode(_component_AppButton, {
            text: "Cancel",
            type: "secondary"
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})